<template>
  <div 
    v-if="!loading"
    class="product">
    <div v-if="currentProduct !== undefined" class="breadcrumbs__container">
      <BreadCrumbs :node="currentProduct" :currentSlug="currentProduct.fields.slug"/>
    </div>
    <ZenitBackground :slug="slug"/>
    <ProductGallery :slug="slug"/>
    <ProductSameCategory :slug="slug"/>
    <!--
    <swiperCosaUsare
      :overlineTitle="'cosa usare per …'"
      :category="'All'"
      :currentSlug="undefined"/>
    -->
    <FooterArea/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BreadCrumbs from '@/components/BreadCrumbs/BreadCrumbs.vue'
import ZenitBackground from '@/components/ZenitBackground/ZenitBackground.vue'
import ProductGallery from '@/components/ProductGallery/ProductGallery.vue'
import ProductSameCategory from '@/components/ProductSameCategory/ProductSameCategory.vue'
import FooterArea from '@/components/FooterArea/FooterArea.vue'

export default {
  name: 'Product',
  components: {
    BreadCrumbs,
    ZenitBackground,
    ProductGallery,
    ProductSameCategory,
    FooterArea
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'product',
      'nodes'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    },
    currentNode: {
      get () {
        if (typeof this.currentProduct === 'undefined') return undefined
        return this.nodes.find(node => {
          if (typeof node.fields.products === 'undefined') return false
          return node.fields.products.find(product => {
            return product.sys.id === this.currentProduct.sys.id
          }) !== undefined
        })
      }
    },
    currentCategoryTitle: {
      get() {
        if (typeof this.currentNode === 'undefined') return ''
        return this.currentNode.fields.category.fields.title
      }
    },
    loading: {
      get () {
        return typeof this.currentProduct === 'undefined'
      }
    }
  },
  beforeRouteEnter (from, to, next) {
    next(async (vm) => {
	    await vm.loadData()
      if (typeof vm.currentProduct === 'undefined') vm.$router.replace({ name: 'not-found-page' })
    })
  },
  beforeRouteUpdate (from, to, next) {
    this.loadData()
    next()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    async loadData () {
      try {
        await this.loadProducts()
        window.prerenderReady = true
      } catch (e) {
        // TODO sentry
      }
    },
    $_changeStep (step) {
      this.$emit('change-step', step)
    }
  },
  metaInfo () {
    if (!this.loading) return {
      title: this.currentProduct.fields.seoTitle.length >= 40 ? `${this.currentProduct.fields.seoTitle} | Colorificio Postumia` : `${this.currentProduct.fields.title} ${this.currentProduct.fields.listingFeatures} - ${this.currentCategoryTitle} | Colorificio Postumia`,
      meta: [
        { vmid: 'description', name: 'description', content: this.currentProduct.fields.seoDescription.length >= 100 ? this.currentProduct.fields.seoDescription : `Descrizione e scheda tecnica del prodotto ${this.currentProduct.fields.seoTitle} della ${this.currentProduct.fields.listingFeatures}. ${this.currentCategoryTitle} delle migliori marche in vendita nel Colorificio Postumia.` },
        { property: 'og:locale', content: 'it' },
        { property: 'og:title', content: this.currentProduct.fields.seoTitle.length >= 40 ? `${this.currentProduct.fields.seoTitle} | Colorificio Postumia` : `${this.currentProduct.fields.title} ${this.currentProduct.fields.listingFeatures} - ${this.currentCategoryTitle} | Colorificio Postumia` },
        { property: 'og:description', content: this.currentProduct.fields.seoDescription.length >= 100 ? this.currentProduct.fields.seoDescription : `Descrizione e scheda tecnica del prodotto ${this.currentProduct.fields.seoTitle} della ${this.currentProduct.fields.listingFeatures}. ${this.currentCategoryTitle} delle migliori marche in vendita nel Colorificio Postumia.` },
        { property: 'og:url', content: `/prodotto/${this.slug}` },
        { property: 'og:image', content: `${this.currentProduct.fields.mainPicture.fields.file.url}?w=1024&fit=scale` }
      ],
      link: [
        { rel: 'canonical', href: location.protocol + '//' + location.host + location.pathname }
      ]
    }
    return {
      title: 'Loading...',
      meta: [
        { vmid: 'description', name: 'description', content: 'Loading...' },
        { property: 'og:locale', content: 'Loading...' },
        { property: 'og:title', content: 'Loading...' },
        { property: 'og:description', content: 'Loading...' },
        { property: 'og:url', content: 'Loading...' },
        { property: 'og:image', content: 'Loading...' }
      ]
    }
  }
}
</script>

<style>

</style>
